// 非ログイン状態の場合 Cookie2Token を呼んでトークン取得してからAPIを呼び出すラッパー
// Cookie2Token を呼んでログイン状態になった場合 UserInfo の登録も実施する
import createClient from "openapi-fetch";
import type { paths } from "~/types/entity/emerIntwcApiWeb.schema";
import type { AccessTokenWithLoginOption } from "~/types/entity/user";

export const createOpenapiFetch = async (fetchOption: AccessTokenWithLoginOption) => {
  const accessToken = await fetchOption.getAccessTokenWithLogin(); // await getAccessTokenWithLogin(fetchOption);
  if (!accessToken) {
    return undefined;
  }
  const client = createClient<paths>({
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
  return client;
};
